module.exports = __webpack_public_path__ + "static/img_0-c57f6b23a94285e637eb25c21d8ec7c3.png";